import Swiper from "swiper";

export default () => {

	const collectionSliders = document.querySelectorAll('.js-collection-styles-slider');
	if (!collectionSliders.length) return;

	collectionSliders.forEach(sliderEl => {

		const slider = new Swiper(sliderEl, {
			slidesPerView: 'auto',
			spaceBetween: 4
		});

	})

}
